module.exports = __webpack_public_path__ + "static/media/SarahSwitek_05_BodySensations-Confirmation_4.9a54b8bb.mp3";